var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44507 3.22198C5.44507 2.63261 5.67919 2.06738 6.09594 1.65063C6.51269 1.23388 7.07792 0.999756 7.66729 0.999756H18.7784C19.3678 0.999756 19.933 1.23388 20.3497 1.65063C20.7665 2.06738 21.0006 2.63261 21.0006 3.22198V14.3331C21.0006 14.9225 20.7665 15.4877 20.3497 15.9044C19.933 16.3212 19.3678 16.5553 18.7784 16.5553H7.66729C7.07792 16.5553 6.51269 16.3212 6.09594 15.9044C5.67919 15.4877 5.44507 14.9225 5.44507 14.3331V3.22198Z",
    stroke: "url(#paint0_linear_842_1811)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5556 16.5559V18.7782C16.5556 19.3675 16.3214 19.9328 15.9047 20.3495C15.4879 20.7663 14.9227 21.0004 14.3333 21.0004H3.22222C2.63285 21.0004 2.06762 20.7663 1.65087 20.3495C1.23413 19.9328 1 19.3675 1 18.7782V7.66705C1 7.07768 1.23413 6.51245 1.65087 6.0957C2.06762 5.67895 2.63285 5.44482 3.22222 5.44482H5.44444",
    stroke: "url(#paint1_linear_842_1811)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_1811",
    x1: 5.16284,
    y1: 9.10386,
    x2: 21.2542,
    y2: 9.10386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_1811",
    x1: 0.71777,
    y1: 13.5489,
    x2: 16.8091,
    y2: 13.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversity);
export default __webpack_public_path__ + "static/media/diversity.f96ca17bc70c1212be4c09975d61cf69.svg";
export { ForwardRef as ReactComponent };